import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  IRideBottomSiteDisplayItem,
  RideBottomSiteItemVariant,
} from "../ride-tabs-bottom-sites.models";
import { formatRideBottomSitePassengerLines } from "../ride-tabs-bottom-sites.utils";
import { RideTabsBottomSitesTooltipStyled } from "./ride-tabs-bottom-sites-tooltip.styled";

interface IRideTabsBottomSitesTooltipProps {
  item: IRideBottomSiteDisplayItem;
}

export const RideTabsBottomSitesTooltip: FC<
  IRideTabsBottomSitesTooltipProps
> = ({ item }) => {
  const { t } = useTranslation();
  const passengerLines = formatRideBottomSitePassengerLines(item.passengers);

  if (item.variant === RideBottomSiteItemVariant.RideSiteMismatch) {
    return (
      <RideTabsBottomSitesTooltipStyled>
        <span>{t("ride.bottomSites.noPassengersOnRideSite")}</span>
      </RideTabsBottomSitesTooltipStyled>
    );
  }

  if (!passengerLines.length) {
    return null;
  }

  return (
    <RideTabsBottomSitesTooltipStyled>
      {passengerLines.map(line => (
        <span key={line}>{line}</span>
      ))}
      {item.showNotEqualToRideSiteNote && (
        <span>{t("ride.bottomSites.notEqualToRide")}</span>
      )}
    </RideTabsBottomSitesTooltipStyled>
  );
};
